import { useVisibleTasksList } from './useVisibleTasksList';
import { useOnboardingGoals } from './useOnboardingGoals';
import { getFirstNotDoneTaskIndex } from '../tools/getFirstNotDoneTaskIndex';

export const useFinishedOnboarding = (): boolean => {
    const onboardingGoals = useOnboardingGoals();
    const onboardingTasksList = useVisibleTasksList(onboardingGoals);
    return getFirstNotDoneTaskIndex(onboardingTasksList) < 0;
};
